import { Button } from "../../../../components/ui/button";
import { Link } from "react-router-dom";

const Hero: React.FC = () => {
	return (
		<div className="relative bg-gradient-to-r from-purple-600 to-indigo-800 text-white py-24">
			<div className="absolute inset-0 bg-grid-white/[0.2] bg-grid-16" />
			<div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
				<h1 className="text-4xl md:text-6xl font-bold mb-6">
					大船渡ハッカソン
				</h1>
				<p className="text-xl md:text-2xl mb-8 text-purple-100">
					アイデアを形に、仲間とともに。
					<br className="hidden md:block" />
					地域の課題をテクノロジーで解決しよう。
				</p>
				<div className="flex flex-col sm:flex-row gap-4 justify-center">
					<Button
						asChild
						size="lg"
						className="bg-white text-purple-600 hover:bg-purple-50"
					>
						<Link to="/hackathon/entry">エントリーする</Link>
					</Button>
					<Button
						asChild
						size="lg"
						variant="outline"
						className="text-white border-white hover:bg-purple-500"
					>
						<Link to="/hackathon/about">詳細を見る</Link>
					</Button>
				</div>
			</div>
		</div>
	);
};

export default Hero;
